// Share `subscribers`, `subscribe`, `publish`, and PUB_SUB_EVENTS across loads.
// Without window-stashing, re-loading this script (theme editor section reload, AJAX nav) wipes all prior subscriptions and leaves dangling callbacks holding stale references.
window.subscribers = window.subscribers || {};
let subscribers = window.subscribers;

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => cb !== callback);
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      try { callback(data); } catch (err) { console.error('[pubsub] subscriber for "' + eventName + '" threw:', err); }
    });
  }
}

// Expose to window so other scripts can use these from any load order.
window.subscribe = subscribe;
window.publish = publish;
